module.exports = __webpack_public_path__ + "static/img/1692694560975.793b495f.jpg";